exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".microsoftYaHei[data-v-0bae89d5]{font-family:Microsoft YaHei regular}", ""]);

// exports
